export default __webpack_public_path__ + "static/heatlh-ehr-medical-a02356c284be1487f591f6a5d2eb0919.png";